import { render, staticRenderFns } from "./addDia.vue?vue&type=template&id=1cd6c568&scoped=true&"
import script from "./addDia.vue?vue&type=script&lang=js&"
export * from "./addDia.vue?vue&type=script&lang=js&"
import style0 from "./addDia.vue?vue&type=style&index=0&id=1cd6c568&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd6c568",
  null
  
)

export default component.exports